<template>
    <div>
        <div class="bg-white">
            <div class="container">
                <div class="row">
                    <nav class="col-12">
                        <ul class="o-booking-nav">
                            <li v-for="step in steps" v-bind:key="step.name" :class="{ active: step.name == current }">{{step.label}}</li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>

        <div class="o-booking-header bg-sec cl-white">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="o-booking-header__inner">
                            <a class="btn btn-white-alt is-smaller txt-init" :href="searchFormURL">Modify search</a>

                            <div class="text-md-center mt-4 mt-md-0">
                                <h2 class="c-ttl c-ttl--mdp">
                                    {{ getPortById(legs.out.origin).name }}
                                    <span :class="{
                                        'icon-compare-arrows fs-16': ticket != 'oneway' && !multicity,
                                        'icon-arrow-right fs-10': ticket == 'oneway' || multicity
                                    }" class="cl-sec-l d-inline-flex mx-3 pb-1"></span>
                                    {{ getPortById(legs.out.destination).name }}
                                    
                                    <span v-if="multicity">
                                        <span v-if="legs.out.destination != legs.ret.origin">
                                            <span class="icon-arrow-right fs-10 cl-sec-l d-inline-flex mx-3 pb-1"></span>
                                            {{ getPortById(legs.ret.origin).name }}
                                        </span>
                                        <span class="icon-arrow-right fs-10 cl-sec-l d-inline-flex mx-3 pb-1"></span>
                                        {{ getPortById(legs.ret.destination).name }}
                                    </span>
                                </h2>

                                <p class="mt-1 mb-0">{{ tripInfo }}</p>
                            </div>

                            <booking-cart></booking-cart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BookingCart from './BookingCart.vue'

import { mapState, mapGetters } from 'vuex'
export default {
    components: {
        BookingCart,
    },
    computed: {
        ...mapState('booking', {
            steps: 'steps',
            current: 'step',
            ticket: 'ticket',
            legs: 'legs',
            multicity: 'multicity',
            passengersCount: 'passengersCount',
        }),
        ...mapGetters([
            'getPortById'
        ]),
        searchFormURL() {
            let params = new URLSearchParams()
            params.append('out_date', this.legs.out.date)
            params.append('out_origin', this.legs.out.origin)
            params.append('out_destination', this.legs.out.destination)
            params.append('ticket', this.ticket + (this.multicity ? '_multicity' : ''))
            params.append('pax_adl', this.passengersCount.adl)
            params.append('pax_chd', this.passengersCount.chd)
            params.append('pax_inf', this.passengersCount.inf)
            if (this.ticket != 'oneway') {
                params.append('ret_date', this.legs.ret.date)
                params.append('ret_origin', this.legs.ret.origin)
                params.append('ret_destination', this.legs.ret.destination)
            }
            return window.venezialines.home_url+'?'+params.toString()
        },
        tripInfo() {
            let info = [
                this.$store.state.tickets[this.ticket]
            ]
            let dates = [
                moment(this.legs.out.date).format('ddd DD MMM')
            ]
            if (this.ticket == 'return') {
                dates.push(moment(this.legs.ret.date).format('ddd DD MMM'))
            }
            info.push(dates.join(' - '))
            let paxCategories = {
                adl: 'Adult',
                chd: 'Child',
                inf: 'Infant',
            }
            Object.keys(this.passengersCount).forEach(category => {
                if (this.passengersCount[category] > 0) {
                    info.push(this.passengersCount[category]+'x '+paxCategories[category])
                }
            })
            return info.join(', ')
        }
    },
    methods: {
    }
}
</script>